export default __webpack_public_path__ + "static/media/ice_mint.a033e4e2.png";